export const aiVisibilityIndex = {
  "universities": [
    {
      "name": "Warwick Business School (YOU)",
      "ai_visibility_score": 75,
      "content_quality": 80,
      "digital_presence": 70,
      "innovation_index": 78,
      "ai_adoption_rate": 72
    },
    {
      "name": "University of Oxford",
      "ai_visibility_score": 90,
      "content_quality": 92,
      "digital_presence": 88,
      "innovation_index": 94,
      "ai_adoption_rate": 89
    },
    {
      "name": "London Business School",
      "ai_visibility_score": 85,
      "content_quality": 87,
      "digital_presence": 84,
      "innovation_index": 90,
      "ai_adoption_rate": 86
    }
  ],
  "chart_data": {
    "title": "AI Visibility Index",
    "data": [
      {
        "name": "Warwick Business School (YOU)",
        "value": 75
      },
      {
        "name": "University of Oxford",
        "value": 90
      },
      {
        "name": "London Business School",
        "value": 85
      }
    ]
  },
  "context": {
    "title": "AI Visibility Analysis",
    "insights": [
      "University of Oxford leads in AI visibility, driven by high innovation and content quality.",
      "London Business School has a strong digital presence contributing to its high visibility score.",
      "Warwick Business School shows potential with solid content quality and innovation index, though digital presence could be improved."
    ],
    "citations": [
      {
        "source": "QS World University Rankings",
        "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
        "title": "Top MBA Programs in UK 2025 - QS World University Rankings",
        "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Financial Times",
        "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
        "title": "Financial Times MBA Rankings 2025 - UK Business Schools",
        "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Complete University Guide",
        "url": "https://www.thecompleteuniversityguide.co.uk/league-tables/rankings",
        "title": "Complete University Guide - MBA Rankings UK",
        "snippet": "Comprehensive university rankings and guides for MBA programs in the UK, including admission requirements and program comparisons.",
        "confidence": 0.7,
        "category": "rankings"
      }
    ]
  },
  "timestamp": "2025-09-11T18:01:42.794765",
  "model_meta": {
    "model_used": "gpt-4o",
    "search_engines": [
      "DuckDuckGo Web Search"
    ],
    "data_freshness": "live",
    "processing_time": 8.14,
    "web_search_used": true,
    "citation_count": 3
  }
};
